import { Step, StepLabel, Stepper } from '@material-ui/core';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import markdown from '@opsbase/react-markdown';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import * as React from 'react';
const styles = {
    container: {
        borderRadius: 20,
        border: `1px solid ${Palette.InputBorderGrey.main}`,
        height: 300,
        width: 230,
        margin: 20,
        marginTop: 40,
        marginRight: 5,
        backgroundColor: Palette.White.main,
    },
    header: {
        height: 30,
        display: 'flex',
        backgroundColor: Palette.primary.main,
        color: Palette.White.main,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
    },
};
export function OnboardingProgress(props) {
    function renderRow(stepNumber, title, text) {
        return (React.createElement(Horizontal, null,
            React.createElement(Vertical, { style: {
                    color: step === stepNumber ? '' : Palette.GreyBlue.main,
                } },
                React.createElement(Text, null, title),
                React.createElement(Text, null, text))));
    }
    const { step } = props;
    const steps = [{ label: 1 }, { label: 2 }, { label: 3 }, { label: 4 }];
    return (React.createElement("div", { style: styles.container },
        React.createElement("div", { style: styles.header },
            React.createElement(Text, { variant: 'h1', style: { margin: 'auto' } }, i18n.t('progress'))),
        React.createElement(Horizontal, null,
            React.createElement(Vertical, { gutter: true, padding: true },
                renderRow(1, i18n.t('ops'), markdown(i18n.t('what-needs-to-be-done'))),
                renderRow(2, i18n.t('places'), markdown(i18n.t('where-should-it-be-done'))),
                renderRow(3, i18n.t('teams-and-roles'), markdown(i18n.t('who-should-do-it'))),
                renderRow(4, i18n.t('schedule'), markdown(i18n.t('when-should-it-be-done')))),
            React.createElement(Stepper, { style: { paddingTop: 20, paddingBottom: 20 }, activeStep: step - 1, orientation: "vertical" }, steps.map(() => (React.createElement(Step, null,
                React.createElement(StepLabel, null))))))));
}
export default OnboardingProgress;
